import React, { useEffect, useState } from "react";
// import { Blogs } from "../../../asset/json/Blog.json";
import PropTypes from "prop-types";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { NavLink } from "react-router-dom";
import { Card } from "react-bootstrap";
import "./blogSidebar.scss";
import AllCategories from "../blog/BlogCategory/AllCategories";
import { Scrollbars } from "react-custom-scrollbars";
import firebase from "../../../firebase";
import { SignupForm } from "./SignupForm";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `nav-tab-${index}`,
    "aria-controls": `nav-tabpanel-${index}`,
  };
}

function LinkTab(props) {
  return (
    <Tab
      component="a"
      onClick={(event) => {
        event.preventDefault();
      }}
      {...props}
    />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export const BlogSidebar = (props) => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const theme = useTheme();

  const handleChangeIndex = (index) => {
    setValue(index);
  };
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    setPosts(posts);
    getData();
  }, []);

  const [items, setItems] = useState([]);
  const ref = firebase.collection("/blog");
  function getData() {
    ref.onSnapshot((data) => {
      const item = [];
      data.forEach((doc) => {
        item.push(doc.data());
      });
      setItems(
        item.sort((a, b) => {
          return b.id - a.id;
        })
      );
    });
  }
  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Tabs
          // variant="fullWidth"
          value={value}
          onChange={handleChange}
          aria-label="nav tabs example"
          className="tabs"
        >
          <LinkTab
            className="tab"
            label="Recent"
            //  href="/drafts"
            {...a11yProps(0)}
          />
          <LinkTab
            className="tab"
            label="Popular"
            // href="/trash"
            {...a11yProps(1)}
          />
          <LinkTab
            className="tab"
            label="Categories"
            //href="/spam"
            {...a11yProps(2)}
          />
        </Tabs>
      </AppBar>

      <TabPanel value={value} index={0}>
        <Card className="recentCard" style={{marginBottom:"10px"}}>
          <Scrollbars
            autoHide
            autoHeight
            autoHeightMin={400}
            autoHeightMax={400}
          >
            {items.map((post) => {
              {
                /* {Blogs.map((post) => { */
              }
              return (
                <NavLink
                  className="recentBlogNavLink"
                  key={post.id}
                  to={`/blog/${post.title}`}
                >
                  <Card className="recentBlogCard">
                    <Card.Img
                      className="recentBlogImage"
                      variant="top"
                      src={post.blogImage}
                    />
                    <Card.Body style={{ padding: "0px" }}>
                      <Card.Title className="recentBlogTitle">
                        {post.heading}
                      </Card.Title>
                      <Card.Footer>
                        <small className="text-muted recentPostedOn">
                          {post.date} / by CloudSocial Admin
                        </small>
                      </Card.Footer>
                    </Card.Body>
                  </Card>
                </NavLink>
              );
            })}
          </Scrollbars>
        </Card>
        {/* <SignupForm /> */}
      </TabPanel>
      <TabPanel value={value} index={1}>
        <AllCategories name={items} />
        {/* <SignupForm /> */}
      </TabPanel>
      <TabPanel value={value} index={2}>
        <AllCategories name={items} />
        {/* <SignupForm /> */}
      </TabPanel>
    </div>
  );
};
